// owner/api/ownerWrites.js — the only changes an owner makes, all to their OWN account (owners are view-only on
// every business record: units, bookings, prices, guests — tasks/owner-mobile-app-build.md §10 "Owners are
// view-only"). On secureApi, like every owner call. The store-review demo account may switch its own alerts
// (DEMO_ALLOWED_WRITES) and is refused a password change with AUTH_013.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { secureApi } from '../../services/secureApi';
import { notificationApi } from '../../services/notificationApi';

/** Switch one alert type on or off; the settings answer is re-read after, so the switch shows the server's state. */
export const useSetAlertPreference = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ type, enabled }) => notificationApi.setPreference(type, enabled),
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['owner', 'alerts'] })
  });
};

/**
 * Change the password. On success the server has already ended EVERY session, this one included
 * (passwordResetService.changePassword), so the screen signs the owner out. Failures carry a code:
 * VAL_004 (under the minimum), AUTH_001 (wrong current password), AUTH_013 (demo account).
 */
export const useChangePassword = () => useMutation({
  mutationFn: ({ currentPassword, newPassword }) =>
    secureApi.post('/api/v1/users/change-password', { currentPassword, newPassword }).then((res) => res.data)
});

/**
 * «إشعار تجريبي»: one test alert to every device this owner has switched on (the server's test send; demo allowed).
 * Failures carry a code: PUSH_006 (no device on yet), PUSH_001/002 (alerts off on the server), PUSH_007 (not sent).
 */
export const useSendTestAlert = () => useMutation({ mutationFn: () => notificationApi.test() });
